import { useNavigate } from "react-router-dom";
import { useCommercialSummary } from "@/lib/commercialQueries";

/**
 * Commercial/CRM — reuses the existing workspace-level Commercial
 * summary as-is (payments/invoices/contracts model the whole
 * engagement, not one member individually).
 */
export default function CommercialTab({ workspaceId }) {
  const navigate = useNavigate();
  const { data, isPending, isError } = useCommercialSummary(workspaceId);

  return (
    <div data-testid="client-360-commercial-tab">
      <div className="flex justify-end mb-3">
        <button
          onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/account/commercial`)}
          className="text-xs text-terracotta hover:underline"
          data-testid="client-360-commercial-open-full-page"
        >
          Open full Commercial Center →
        </button>
      </div>
      {isPending ? (
        <p className="text-sm text-ink-soft" data-testid="client-360-commercial-loading">Loading…</p>
      ) : isError ? (
        <p className="text-sm text-red-600" data-testid="client-360-commercial-error">Couldn't load commercial summary.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="client-360-commercial-summary">
          <div className="border border-ink/10 rounded-lg p-3 bg-white/50">
            <p className="text-lg font-serif text-ink">{data.package?.status || "No package"}</p>
            <p className="text-xs text-ink-soft">Package</p>
          </div>
          <div className="border border-ink/10 rounded-lg p-3 bg-white/50">
            <p className="text-lg font-serif text-ink">{data.invoices.length}</p>
            <p className="text-xs text-ink-soft">Invoices</p>
          </div>
          <div className="border border-ink/10 rounded-lg p-3 bg-white/50">
            <p className="text-lg font-serif text-ink">{data.contracts.length}</p>
            <p className="text-xs text-ink-soft">Contracts</p>
          </div>
        </div>
      )}
    </div>
  );
}
